import { Component, OnInit, HostListener, Input, ElementRef } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Global } from 'src/app/core/resources/global';

@Component({
  selector: 'app-cargo-locations',
  templateUrl: './cargo-locations.component.html',
  styleUrls: ['./cargo-locations.component.scss'],
  providers: [AuthService, Global]
})

export class LocationsFreightComponent implements OnInit {

  constructor(private eRef: ElementRef) {}

  @Input() fixedAddressMapActive: any;

  ngOnInit() {

  }

  fixedAddressMap() {
    this.fixedAddressMapActive = true;
  }
  
}
